import React, { useState} from "react";
import { faCheck, faClose, faDotCircle, faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";



const OptionBtn = ({onSelect, selected, sub, reset}) => {
    return (
    <button 
        className={classNames("eval-btn-box",{"submitted": sub})} 
        onClick={onSelect}
        disabled={sub}
    >
            <FontAwesomeIcon 
                icon={faDotCircle} 
                color={ (selected? "#2d4a5f" : "#efefef")} 
            />
    </button>
    );
}

const MarkBtn =  ({isCorrect, selected, submited}) => {
    return (
        <button className={classNames("tick-cross-box",{'submitted': submited})}>
             {selected &&
             <FontAwesomeIcon 
                icon={isCorrect? faCheck : faClose} 
                color={isCorrect? "#0f0" : "#f00"} 
             />}
        </button>
    );
}


export const QuestionUnit = ({questionData, indx, addAnswer, isCorrect, submited,cancel, isSuperAdmin, questionsId }) => {
    const answerOptions = ['A','B','C','D'];
    const [chosen, setChosen] = useState();
    const chooseAnswer = (k) => {
        addAnswer(k)
    }

    const navigateTo = useNavigate();

    React.useEffect(() => {
        if (cancel) {
            setChosen();
        }
    },[cancel])
   
    return (
        <div className="q-unit-container">
            <div className="answer-unit-top">
                <span className="q-number">{indx+1}</span>
                <span className="unit-question">{questionData?.question}</span>
            </div>
            <div className="unit-bottom">
                {questionData.options.map((answ, k) => (
                    <div className="answer-unit" key={k}>
                        <span className="ans-option-text">{answerOptions[k]}</span>
                        <OptionBtn 
                            onSelect={(e) => {
                                e.preventDefault();
                                setChosen(k);
                                chooseAnswer(k);
                            }} 
                            selected={chosen === k}
                            sub={submited}
                            reset={cancel}
                        />
                        <span className="option">{answ}</span>
                        <MarkBtn
                           isCorrect={isCorrect}
                           selected={chosen === k}
                           submited={submited}
                        />
                    </div>
                ))}
            </div>
            { isSuperAdmin &&
            <div className="adm-edit">
                <button 
                    className="tr-btn"
                    onClick={() => {
                        navigateTo("/updatequestion", {state: {question: questionData, qId: questionsId }})
                    }}
                >
                    <FontAwesomeIcon icon={faEdit} size={24} />
                </button>
            </div>
            }
        </div>
    );
}